import breakpoints from './breakpoints';

export const CommonTheme = {
  white: `#ffffff`,
  greyVeryLight: `#f2f2f2`,
  greyLight: `#E0E0E0`,
  greyMedium: `#575D7A`,
  greyDark: `#131523`,
  black: `#000000`,

  statusSuccess: `#4fd05c`,
  statusSuccessLight: `#e0f2e1`,
  statusDanger: `#e00000`,
  statusDangerLight: `#f7e1e1`,
  statusWarning: `#f99033`,
  statusWarningLight: `#fff7dd`,
  statusInfo: `#0090c8`,
  statusInfoLight: `#e4f3f9`,

  spacing: `16px`,
  spacingSm: `8px`,
  spacingMd: `24px`,
  spacingLg: `32px`,
  spacingXl: `64px`,

  headerHeight: '80px',
  footerHeight: '60px',
  fontNormal: '400',
  fontMedium: '500',
  fontBold: '700',

  primary: `#28BF8D`,
  primaryLight: `#36dca6`,
  primaryDark: `#219a72`,

  primaryAlpha10: `rgba(26, 85, 73, 0.10)`,
  primaryAlpha15: `rgba(26, 85, 73, 0.15)`,
  primaryAlpha20: `rgba(26, 85, 73, 0.20)`,

  secondary: `#491F69`,

  ...breakpoints,
};
